export default "__VITE_ASSET__Czy6kBcp__"